<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <div
    :class="
      cn(
        'flex items-center p-5 bg-gray-100 border-t border-t-gray-200',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
